import { render, staticRenderFns } from "./GatewayExpense.vue?vue&type=template&id=f4a69734"
import script from "./GatewayExpense.vue?vue&type=script&lang=js"
export * from "./GatewayExpense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports